import { Controller } from "@hotwired/stimulus"
import createApp from '@/javascript/components/blog-posts/app'

// Connects to data-controller="blog"
export default class extends Controller {
  connect() {
    this.element.vm = createApp(this.element)
  }
}
